import { render, staticRenderFns } from "./kasbank.vue?vue&type=template&id=5a23bd4c&scoped=true"
import script from "./kasbank.vue?vue&type=script&lang=js"
export * from "./kasbank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a23bd4c",
  null
  
)

export default component.exports